import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getTopCriticalPathRemoved';

export const getCriticalPathRemovedTableData = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
